var __jsx = React.createElement;
import React, { useContext } from "react";
import AwesomeIcon from "../AwesomeIcon";
import { faCircleCheck, faDiamondExclamation } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import { GatewayContext } from "./GatewayContext";
import { format } from "date-fns";
import { truncate } from "lodash";
import { t } from "i18next";
function GatewayDropdown() {
  var _useContext = useContext(GatewayContext),
    totalGateway = _useContext.totalGateway,
    offlineGatewayCount = _useContext.offlineGatewayCount,
    offlineGatewayData = _useContext.offlineGatewayData,
    formatTimeDifference = _useContext.formatTimeDifference;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-gray-900 dark:text-gray-100 text-md"
  }, !offlineGatewayCount ? /*#__PURE__*/React.createElement("div", {
    className: "bg-green-300 dark:bg-green-800 flex space-x-4 px-5 py-4 items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircleCheck,
    className: "text-green-700 dark:text-green-400"
  }), /*#__PURE__*/React.createElement("p", {
    className: "font-medium text-md"
  }, t("gateways_are_online", {
    totalGateway: totalGateway
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-yellow-300 dark:bg-yellow-800 flex space-x-4 px-5 py-4 items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faDiamondExclamation,
    className: "text-yellow-700 dark:text-yellow-500"
  }), /*#__PURE__*/React.createElement("p", {
    className: "font-medium text-md"
  }, t("gateways_are_offline", {
    offlineGatewayCount: offlineGatewayCount,
    totalGateway: totalGateway
  }))), /*#__PURE__*/React.createElement("div", {
    className: "p-5 max-h-[300px] space-y-5 overflow-y-auto scrollbar-light dark:scrollbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-5"
  }, offlineGatewayData === null || offlineGatewayData === void 0 ? void 0 : offlineGatewayData.map(function (obj, index) {
    var _obj$gateway;
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-md text-gray-600 dark:text-gray-400 uppercase"
    }, obj === null || obj === void 0 ? void 0 : obj.workspace_name), /*#__PURE__*/React.createElement("div", {
      className: "space-y-5"
    }, obj === null || obj === void 0 || (_obj$gateway = obj.gateway) === null || _obj$gateway === void 0 ? void 0 : _obj$gateway.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: classNames("border rounded-lg border-gray-500/50 space-y-2 p-4 my-3")
      }, /*#__PURE__*/React.createElement("p", {
        className: "font-medium",
        title: item === null || item === void 0 ? void 0 : item.gateway_name
      }, truncate(item === null || item === void 0 ? void 0 : item.gateway_name, {
        length: 30
      })), /*#__PURE__*/React.createElement("p", {
        className: "text-yellow-600 dark:text-yellow-500"
      }, t("offline_for"), " ", formatTimeDifference(item === null || item === void 0 ? void 0 : item.time_difference), " ", /*#__PURE__*/React.createElement("span", {
        className: "text-gray-800 dark:text-gray-200"
      }, t("since_key"), " ", format(new Date(item === null || item === void 0 ? void 0 : item.last_online), "h:mm a, d MMM"), " ")));
    })));
  })))));
}
export default GatewayDropdown;